import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportKeroseneTable() {
  // Store
  const { kerosene } = useEnergyPassportDetailsStore()

  return <EnergyPassportDetailsTable title="Энергетический баланс керосина" storeItem={kerosene} />
}
